import reducer from "./reducer";
export { default as IssueTypesSettingsFunctions } from "./components/index";
export { default as issueTypesSettingsReducerName } from "./constants";
export default reducer;
